let factoryTreeProps = {
  children: '',
  label: 'codeName'
}

let scoreLowest = 90

let cardCertType = []
let merchantType = []
let genderType = []
let cardTaskType = []
let mediaType = []
let departmentType = []
let deviceMaintenanceType = []

let personStatus = []
let cardStatus = []
let makeCardTaskStatus = []
let deviceStatus = []

let personList = []
let personFaceList = []
let cardBasicInfoList = []
let deviceList = []
let cardTaskRecordList = []
let deviceVersionRecordList = []
let personCardList = []
let cardHistoryList = []

let reportTranType = []// 充值明细报表的交易类型

let makeCardStep = {
  '1': '创建任务',
  '2': '审批任务',
  '3': '导入客户信息',
  '4': '开卡',
  '5': '导入卡资料',
  '6': '导入卡号',
  '7': '导出卡号',
  '8': '导出制卡数据',
  '9': '导入卡序对照文件',
  '10': '导入卡序对照文件',
  '999': '结束'
}
let makeCardFlow = {
  '1': '1',
  '2': '2',
  '3': '3',
  '4': '8',
  '5': '9',
  '11': '1',
  '12': '2',
  '13': '4',
  '14': '7',
  '15': '10',
  '21': '1',
  '22': '2',
  '23': '5',
  '31': '1',
  '32': '2',
  '33': '6',
  '999': '999'
}
let dealWithStepId = ['3', '5', '6', '9', '10']
let exportStepId = ['7', '8']

let cardInfoFileHead = '部门、姓名、人员类别、人员职务、人员编号、性别、证件类型、证件号码、手机号码、有效期、外部卡号、卡序号'
let customInfoFileHead = '部门、姓名、人员类别、人员职务、人员编号、性别、证件类型、证件号码、手机号码、有效期'
let cardNumberFileHead = '卡号、物理卡序'

export default {
  factoryTreeProps,
  scoreLowest,
  cardCertType,
  merchantType,
  genderType,
  cardTaskType,
  mediaType,
  makeCardFlow,
  makeCardStep,
  departmentType,
  deviceMaintenanceType,
  personStatus,
  cardStatus,
  makeCardTaskStatus,
  deviceStatus,
  personList,
  personFaceList,
  cardBasicInfoList,
  deviceList,
  cardTaskRecordList,
  deviceVersionRecordList,
  personCardList,
  cardHistoryList,
  dealWithStepId,
  exportStepId,
  cardInfoFileHead,
  customInfoFileHead,
  cardNumberFileHead,
  reportTranType
}



// WEBPACK FOOTER //
// ./src/store/apply_basic/state.js